/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { toUpper } from 'lodash';
import { css, StyleSheet } from 'aphrodite';
import { Text, BrandColors, LinkButton } from '@blend/enterprise-components';
import { BlendBridge } from 'blb-types/blendBridge';
import { openUrlInNewTab } from 'blb-utils/misc';

export const styles = StyleSheet.create({
  summaryCard: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
});

export namespace LoanInfoSummary {
  export interface Props {
    lenderWorkspaceUrlData: BlendBridge.API.LenderWorkspaceUrlData;
  }
}

export const LenderWorkspaceAccessColumn: React.FC<LoanInfoSummary.Props> = ({ lenderWorkspaceUrlData }) => {
  const { loanUrl, loginUrl } = lenderWorkspaceUrlData;

  return (
    <div className={css(styles.summaryCard)}>
      <Text color={BrandColors.NIGHT_80} fontSize="sm" weight="semibold">
        {toUpper(`Lender Workspace`)}
      </Text>
      <Text>
        <LinkButton
          id="it-LoginLinkToLenderWorkspace"
          label="Login to Lender Workspace"
          onClick={() => {
            openUrlInNewTab(loginUrl);
          }}
        />
      </Text>
      <LinkButton
        id="it-LoanLinkInLenderWorkspace"
        label="Access loan in Lender Workspace"
        onClick={() => {
          openUrlInNewTab(loanUrl);
        }}
      />
    </div>
  );
};
